import api from '@pray/shared/utils/api';

import type { RecurringPushCampaignDetail, UpdateRecurringPushCampaignPayload } from './types';

// PATCH …/campaigns/recurring-push/:id — partial update, status-gated server-side.
// The payload should carry only fields editable for the current status; the
// server rejects anything else with RECURRING_FIELD_NOT_EDITABLE.
export async function updateRecurringPushCampaign({
  artistId,
  recurringCampaignId,
  payload,
}: {
  artistId: string;
  recurringCampaignId: string;
  payload: UpdateRecurringPushCampaignPayload;
}): Promise<{ object: RecurringPushCampaignDetail }> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!recurringCampaignId) throw new Error('Recurring campaign ID is required');

  const url = `/web/studio/artists/${artistId}/campaigns/recurring-push/${recurringCampaignId}`;
  const response = await api.executePatchRequest<{ data: { object: RecurringPushCampaignDetail } }>(url, payload);
  return response.data.data;
}
